import { t } from "i18next";
import Hamburguer from "../../images/hamburguer.svg"

function HamburguerButton(props) {
  return (
    <button onClick={props.onClick} className={`canvas-options__item user-interface__option-item ${props.hide ? 'hidden' : ''}`}>
      <img src={Hamburguer} alt={t('alt_hamburguer_button')}></img>
    </button>
  );
}

export default HamburguerButton;